/* Live Free — cart drawer (DESIGN-07 Part B).
   1. Every bespoke add (fetch to /cart/add.js from the shelf, quiz, kit, wildcard)
      is asked for the drawer's section HTML on the way out and replayed as the
      cart:change Prestige expects, so the drawer re-renders and opens.
   2. The mom moment: picks state 1 (known adult — quiz handoff, gift note) or
      state 2, shows once per session, plain dismiss. Re-applied after every
      re-render, because Prestige swaps the whole section.
   3. "Remove the kit": one /cart/update.js with every kit line at 0. */
(function () {
  'use strict';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function sectionId() {
    var d = document.getElementById('cart-drawer');
    var s = d && d.closest('.shopify-section');
    return s ? s.id.replace(/^shopify-section-/, '') : null;
  }
  function replay(cart) {
    if (!cart || !cart.sections) return;
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cart } }));
  }
  if (!window.__lfCartPatched && typeof window.fetch === 'function') {
    window.__lfCartPatched = true;
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (!/\/cart\/add(\.js)?(\?|$)/.test(url)) return nativeFetch.apply(this, arguments);
      var sid = sectionId(); if (!sid) return nativeFetch.apply(this, arguments);
      init = init || {};
      var body = init.body, patched = false;
      if (body instanceof FormData) { if (!body.has('sections')) { body.set('sections', sid); patched = true; } }
      else if (typeof body === 'string') {
        try { var j = JSON.parse(body); if (j && typeof j === 'object' && !j.sections) { j.sections = sid; init.body = JSON.stringify(j); patched = true; } }
        catch (e) { if (body.indexOf('sections=') === -1) { init.body = body + (body ? '&' : '') + 'sections=' + encodeURIComponent(sid); patched = true; } }
      }
      var req = nativeFetch.call(this, input, init);
      if (!patched) return req;
      return req.then(function (res) { if (res.ok) res.clone().json().then(replay).catch(function () {}); return res; });
    };
  }

  /* ---- the mom moment ---- */
  function knownAdult() {
    try { if (sessionStorage.getItem('lf_known_adult') === '1') return true; } catch (e) {}
    return /(^|;\s*)lf_known_adult=1/.test(document.cookie);
  }
  function dismissed() { try { return sessionStorage.getItem('lf_mom_dismissed') === '1'; } catch (e) { return false; } }
  function applyMom() {
    var mom = document.querySelector('[data-lf-mom]');
    if (!mom) return;
    if (dismissed()) { mom.hidden = true; return; }
    var adult = knownAdult();
    mom.querySelector('[data-lf-mom-lead]').textContent = mom.getAttribute(adult ? 'data-lead-1' : 'data-lead-2') || '';
    mom.querySelector('[data-lf-mom-body]').textContent = mom.getAttribute(adult ? 'data-body-1' : 'data-body-2') || '';
    mom.classList.toggle('lf-mom--adult', adult);
    mom.hidden = false;
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-lf-mom-dismiss]')) {
      try { sessionStorage.setItem('lf_mom_dismissed', '1'); } catch (x) {}
      var mom = e.target.closest('[data-lf-mom]'); if (mom) mom.hidden = true;
      return;
    }
    var rk = e.target.closest('[data-lf-remove-kit]');
    if (rk) {
      var updates = {};
      String(rk.dataset.lfRemoveKit).split(',').forEach(function (k) { if (k) updates[k] = 0; });
      var sid = sectionId();
      rk.disabled = true;
      fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates, sections: sid }) })
        .then(function (r) { return r.json(); })
        .then(function (cart) { document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'line-item:change', cart: cart } })); })
        .catch(function () { rk.disabled = false; });
    }
  });
  applyMom();
  ['cart:change', 'cart:refresh'].forEach(function (evt) {
    document.documentElement.addEventListener(evt, function () { setTimeout(applyMom, 60); setTimeout(applyMom, 400); });
    document.addEventListener(evt, function () { setTimeout(applyMom, 60); setTimeout(applyMom, 400); });
  });
  // Prestige swaps the drawer's section wholesale, so watch the body for a fresh mom card
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function (muts) {
      if (pending) return;
      for (var i = 0; i < muts.length; i++) { if (muts[i].target.closest && muts[i].target.closest('#cart-drawer, .shopify-section--cart-drawer')) { pending = true; requestAnimationFrame(function () { pending = false; applyMom(); }); break; } }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();